import usePrivateAxios from "@/common/api/usePrivateAxios"
import { defaultTransformerResponse } from "@/common/constants/defaultTransformerResponse.constant"
import { Mapper } from "@/common/services/mapper"
import { MetaResponse } from "@/common/types/metaResponse"
import { keepPreviousData, useQuery } from "@tanstack/react-query"

type UseHolidaysProps<T> = {
  filters?: {
    search?: string
    page?: number
    date?: string
  }
  mapper?: (data: any) => T,
}

export const useHolidays = <T,>({
  filters: { search = '', page, date } = {},
  mapper = Mapper.default<T>(),
}: UseHolidaysProps<T>) => {
  const privateAxios = usePrivateAxios()

  const {
    data: { data, meta } = defaultTransformerResponse<T>(),
    isPending,
    ...rest
  } = useQuery({
    queryKey: ['holidays', search, page, date],
    queryFn: () => {
      return privateAxios.get(`/calendar/holidays`, {
        params: {
          search,
          page,
          'q[date_eq]': date
        }
      })
    },
    select: (data: { data: { data: any[], meta: MetaResponse } }) => {
      return {
        data: mapper(data?.data?.data),
        meta: data?.data?.meta,
      }
    },
    placeholderData: keepPreviousData,
  })

  return { data, meta, isPending, ...rest }
}
